var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreview = function SvgPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "preview_svg2__a",
    x1: -40.2,
    x2: 194.5,
    y1: 204.2,
    y2: 29.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M100 164.1c-42.2.1-80.8-23.8-99.4-61.7-.7-1.5-.7-3.2 0-4.7 27.1-55 93.7-77.5 148.6-50.3 21.8 10.8 39.4 28.4 50.2 50.2.7 1.5.7 3.2 0 4.7-18.6 37.9-57.2 61.8-99.4 61.7ZM11.3 100c25.9 49 86.6 67.7 135.6 41.8 17.8-9.4 32.4-24 41.8-41.8-25.9-49-86.6-67.7-135.6-41.8-17.8 9.4-32.4 24-41.8 41.8m88.7 37.3c-20.6 0-37.3-16.7-37.3-37.3S79.4 62.7 100 62.7s37.3 16.7 37.3 37.3-16.7 37.2-37.3 37.3m0-63.9c-14.7 0-26.6 11.9-26.6 26.6s11.9 26.6 26.6 26.6 26.6-11.9 26.6-26.6-11.9-26.6-26.6-26.6",
    style: {
      fill: "url(#preview_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgPreview;